// Helper to generate distinct colors with contrast
const generateColor = (isDark) => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    // If dark, generate low values. If light, generate high values.
    for (let i = 0; i < 6; i++) {
        const idx = isDark 
            ? Math.floor(Math.random() * 6) // 0-5 (Darker)
            : Math.floor(Math.random() * 6) + 10; // A-F (Lighter)
        color += letters[idx];
    }
    return color;
};

const getContrastingColor = (hex) => {
    // Simple logic: convert hex to brightness, return black or white
    const r = parseInt(hex.substr(1, 2), 16);
    const g = parseInt(hex.substr(3, 2), 16);
    const b = parseInt(hex.substr(5, 2), 16);
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return (yiq >= 128) ? '#000000' : '#ffffff';
};

const getRandomAccent = () => {
    const accents = [
        '#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6', '#ec4899', '#06b6d4', 
        '#f97316', '#84cc16', '#14b8a6', '#6366f1', '#d946ef'
    ];
    return accents[Math.floor(Math.random() * accents.length)];
};

const gradients = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)',
    'linear-gradient(135deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
    'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
    'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)'
];

const fonts = [
    'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Poppins', 
    'Playfair Display', 'Merriweather', 'Nunito', 'Raleway', 'Oswald',
    'Pacifico', 'Dancing Script'
];

const effects = ['none', 'metallic-gold', 'metallic-silver', 'metallic-bronze', 'metallic-steel'];

export const getRandomTheme = () => {
    const isDark = Math.random() > 0.4; // 60% chance of dark theme
    const useGradient = Math.random() > 0.5; // 50% chance of gradient bg

    let pageBg;
    if (useGradient) {
        pageBg = gradients[Math.floor(Math.random() * gradients.length)];
    } else {
        pageBg = generateColor(isDark);
    }
    
    // If we use a gradient, we assume it's relatively vibrant, so we default card to solid.
    // If page is solid, card should contrast.
    
    const cardBg = isDark ? '#1a1a1a' : '#ffffff';
    const cardBorder = isDark ? '#333333' : '#e2e8f0';
    
    // Text color must be readable on Card Background
    const textColor = isDark ? '#e0e0e0' : '#1e293b'; 

    return {
        colors: {
            background: pageBg,
            text: textColor,
            accent: getRandomAccent(),
            cardBackground: cardBg,
            cardBorder: cardBorder,
        },
        cardStyle: {
            borderRadius: `${Math.floor(Math.random() * 32)}px`,
            borderWidth: `${Math.floor(Math.random() * 4)}px`,
            shadow: Math.random() > 0.5 ? '0 10px 30px -10px rgba(0,0,0,0.3)' : 'none',
            padding: Math.random() > 0.5 ? '24px' : '32px',
            textAlign: Math.random() > 0.6 ? 'center' : 'left'
        },
        fontFamily: fonts[Math.floor(Math.random() * fonts.length)],
        fontEffect: Math.random() > 0.8 ? effects[Math.floor(Math.random() * effects.length)] : 'none'
    };
};